import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'apc-datatable-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss', '../datatable.component.scss']
})
export class FiltersComponent implements OnInit {
  @Output() displaySearchEvent = new EventEmitter<boolean>();
  @Output() clearSearchEvent = new EventEmitter<boolean>();
  @Output() exportCSVEvent = new EventEmitter<boolean>();
  @Output() exportSheetEvent = new EventEmitter<boolean>();
  @Output() copyToClipboardEvent = new EventEmitter<boolean>();
  @Output() refreshDataEvent = new EventEmitter<boolean>();
  @Output() selectTableColumnsEvent = new EventEmitter<boolean>();
  @Output() selectAllColumnsEvent = new EventEmitter<boolean>();
  @Output() unselectAllColumnsEvent = new EventEmitter<boolean>();
  @Output() defaultColumnsEvent = new EventEmitter<boolean>();
  @Output() statusFilterEvent = new EventEmitter<string>();
  @Output() setToken = new EventEmitter(false);

  @Input() columnsToDisplayInDropdown: any;
  @Input() showSearch: boolean = false;
  @Input() enableFilter: boolean = false;
  @Input() isAdministration: boolean = false;
  @Input() selectedTableColumns: any;
  @Input() iconsExpanded: boolean = false;
  public statusActive: boolean = true;
  public statusArchived: boolean = false;

  public columnFilter: boolean = false;
  public gToken: boolean=false;

  constructor(public translate: TranslateService) {}

  ngOnInit(): void {
    // here we checked if user picked filter by status, if yes select it
    if (window.location.search.includes('query')) {
      let query = decodeURIComponent(window.location.search.split('query=')[1]);
      // this is because personas table is  queringy big query, where status is named sys_status
      /*if(window.location.pathname.includes('/dashboard/personas')) {
        statuses = query.split("sys_status==");
      } else {
        statuses = query.split("status==");
      }*/

      if (query.includes('ARCHIVED')) {
        this.statusArchived = true;
      }
      if (query.includes('ACTIVE')) {
        this.statusActive = true;
      }
    }
    if (
      window.location.pathname.includes('/administration/options') ||
      window.location.pathname.includes('/administration/users-management')
    ) {
      this.statusActive = false;
    }
  }

  getLabelClass(labelKey) {
    const labelLength = this.translate.instant(labelKey).length;
    let labelClass = 'label-';

    if (labelLength < 5) labelClass += 'xs';
    else if (labelLength >= 5 && labelLength < 10) labelClass += 'sm';
    else if (labelLength >= 10 && labelLength < 15) labelClass += 'md';
    else if (labelLength >= 15 && labelLength < 30) labelClass += 'lg';
    else labelClass += 'xl';

    return labelClass;
  }

  onClickedOutside(e: any) {
    if (typeof e.target.className === 'string') {
      if (
        !e.target.parentElement?.className.includes('select-utils') &&
        e.target.tagName.toLocaleLowerCase() !== 'input' &&
        !e.target.className.includes('ng-option') &&
        !e.target.className.includes('dropdown-select-label') &&
        !e.target.className.includes('dropdown-select-wrapper')
      )
        this.columnFilter = false;
    }
  }

  showExportOptions() {
    this.iconsExpanded = !this.iconsExpanded;
  }

  statusChange() {
    var activeStatusQuery = '';
    var archivedStatusQuery = '';
    var statusString = 'status';
    let resQuery = '';
    /*if(window.location.pathname.includes('/dashboard/personas')) {
      statusString = "sys_status==";
    }*/
    if (this.statusActive) {
      activeStatusQuery = statusString + '==' + encodeURIComponent('ACTIVE');
    }
    if (this.statusArchived) {
      archivedStatusQuery = statusString + '==' + encodeURIComponent('ARCHIVED');
    }
    if (!this.statusActive && !this.statusArchived) {
      activeStatusQuery = statusString + '==' + encodeURIComponent('ACTIVE');
      archivedStatusQuery = statusString + '==' + encodeURIComponent('ARCHIVED');
      resQuery = activeStatusQuery + ',' + archivedStatusQuery;
    }
    if (this.statusActive) {
      resQuery = activeStatusQuery;
      if (this.statusArchived) {
        resQuery += ',' + archivedStatusQuery;
      }
    } else if (this.statusArchived) {
      resQuery = archivedStatusQuery;
    }
    if (resQuery.length > 0) {
      resQuery = '(' + resQuery + ')';
    }
    this.statusFilterEvent.emit(resQuery);
  }

  getTokenClient(tk:any){ 
    this.setToken.emit(tk);
    this.gToken=true;
  }
}
